import { USER } from "../actions/types";

const initialState = {
  getUser: {
    user: {},
    isFetching: false,
    errorMessage: null,
  },
  updateUser: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  updateUserPassword: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  getAppSettings: {
    settings: null,
    errorMessage: null,
    isFetching: false,
  },
  updateAppSettings: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  createPassword: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  sendPasswordRecoveryEmail: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region USER_GET

    case USER.USER_GET_REQUEST:
      return {
        ...state,
        getUser: {
          user: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case USER.USER_GET_SUCCESS:
      return {
        ...state,
        getUser: {
          user: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case USER.USER_GET_FAIL:
      return {
        ...state,
        getUser: {
          user: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region USER_UPDATE

    case USER.USER_UPDATE_REQUEST:
      return {
        ...state,
        updateUser: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case USER.USER_UPDATE_SUCCESS:
      return {
        ...state,
        updateUser: {
          successMessage: "Bijwerken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case USER.USER_UPDATE_FAIL:
      return {
        ...state,
        updateUser: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region USER_PASSWORD_UPDATE

    case USER.USER_PASSWORD_UPDATE_REQUEST:
      return {
        ...state,
        updateUserPassword: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case USER.USER_PASSWORD_UPDATE_SUCCESS:
      return {
        ...state,
        updateUserPassword: {
          successMessage: "Bijwerken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case USER.USER_PASSWORD_UPDATE_FAIL:
      return {
        ...state,
        updateUserPassword: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region USER_GET_APP_SETTINGS

    case USER.USER_GET_APP_SETTINGS_REQUEST:
      return {
        ...state,
        getAppSettings: {
          settings: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case USER.USER_GET_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        getAppSettings: {
          settings: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case USER.USER_GET_APP_SETTINGS_FAIL:
      return {
        ...state,
        getAppSettings: {
          settings: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region USER_UPDATE_APP_SETTINGS

    case USER.USER_UPDATE_APP_SETTINGS_REQUEST:
      return {
        ...state,
        updateAppSettings: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case USER.USER_UPDATE_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        updateAppSettings: {
          successMessage: "Bijwerken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case USER.USER_UPDATE_APP_SETTINGS_FAIL:
      return {
        ...state,
        updateAppSettings: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region USER_CREATE_PASSWORD

    case USER.USER_CREATE_PASSWORD_REQUEST:
      return {
        ...state,
        createPassword: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case USER.USER_CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        createPassword: {
          successMessage: "Wachtwoord aanmaken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case USER.USER_CREATE_PASSWORD_FAIL:
      return {
        ...state,
        createPassword: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region USER_SEND_PASSWORD_RECOVERY_EMAIL

    case USER.USER_SEND_PASSWORD_RECOVERY_EMAIL_REQUEST:
      return {
        ...state,
        sendPasswordRecoveryEmail: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case USER.USER_SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS:
      return {
        ...state,
        sendPasswordRecoveryEmail: {
          successMessage:
            "U ontvang zo meteen de email (als deze geregistreerd is in het systeem)",
          errorMessage: null,
          isFetching: false,
        },
      };

    case USER.USER_SEND_PASSWORD_RECOVERY_EMAIL_FAIL:
      return {
        ...state,
        sendPasswordRecoveryEmail: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js